import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AuthService } from '../auth.service';
import { AppConstants } from './app.constants';
var Awss3UploadService = /** @class */ (function () {
    function Awss3UploadService(http, auth, appConstants) {
        this.http = http;
        this.auth = auth;
        this.appConstants = appConstants;
    }
    Awss3UploadService.prototype.generateSignedUrl = function (body) {
        var url = environment.apiBase + 's3/sign';
        var headers = { headers: this.auth.getAuthorizationHeaders() };
        return this.http.post(url, body, headers).map(function (response) { return response; }).catch(this.appConstants.errorHandler);
    };
    Awss3UploadService.prototype.generatePublicUrl = function (url, body) {
        var headers = new HttpHeaders();
        headers.set('Content-Type', body.type);
        headers.set('x-amz-acl', 'public-read');
        return this.http.put(url, body, { headers: headers }).map(function (response) { return response; }).catch(this.appConstants.errorHandler);
    };
    return Awss3UploadService;
}());
export { Awss3UploadService };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/shared/awss3-upload.service.ts.pre-build-optimizer.js